import { Flame, Target, TrendingUp, Trophy, Zap } from "lucide-react";

const ITEMS = [
  { icon: Flame, text: "FXTM AFRICA $500 GIVEAWAY LIVE" },
  { icon: Zap, text: "48 HOURS GLOBAL COUNTDOWN" },
  { icon: Target, text: "NO SIGNUP REQUIRED — ENTER ON YOUTUBE" },
  { icon: TrendingUp, text: "SUBSCRIBE @FXTM.AFRICA" },
  { icon: Trophy, text: "10 RANDOM WINNERS ANNOUNCED ON CHANNEL" },
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map(({ icon: Icon, text }) => (
      <span key={text} className="mx-8 flex items-center gap-3 text-sm font-mono font-bold uppercase tracking-[0.25em] text-red-500/90">
        <Icon className="h-4 w-4 text-red-600" />
        {text}
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div data-testid="promo-marquee" className="relative overflow-hidden border-y border-red-600/20 bg-[#FAFAFA] py-4">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
